import AspenZone from "@aspen/Aspen/AspenZone";
import InitMobileNav from "@aspen/Aspen/InitMobileNav";
import InitOpenClose, { initMobileHeaderNavOpenClose } from "@aspen/Aspen/InitOpenClose";
import Person from "@aspen/Store/Aspen/Icons/Person";
import { HasShellContext, withIsInShell } from "@insite/client-framework/Components/IsInShell";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import dismissRfqUpdates from "@insite/client-framework/Store/Context/Handlers/DismissRfqUpdates";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import translate from "@insite/client-framework/Translate";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import { SkipNavStyles } from "@insite/content-library/Components/SkipNav";
import Link from "@insite/mobius/Link";
import Page, { PageProps as MobiusPageProps } from "@insite/mobius/Page";
import { HasToasterContext, withToaster } from "@insite/mobius/Toast/ToasterContext";
import Typography from "@insite/mobius/Typography";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { useEffect } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: ApplicationState) => ({
  siteName: state.context.website.name,
  session: getSession(state),
  userName: state.context.session.userName,
  firstName: state.context.session.firstName,
  myAccountPageUrl: getPageLinkByPageType(state, "MyAccountPage")?.url,
  signInUrl: getPageLinkByPageType(state, "SignInPage")?.url
});

const mapDispatchToProps = {
  dismissRfqUpdates,
};

type Props = PageProps &
  ReturnType<typeof mapStateToProps> &
  ResolveThunks<typeof mapDispatchToProps> &
  HasToasterContext &
  HasHistory & HasShellContext;

export interface HeaderStyles {
  page?: MobiusPageProps;
  container?: InjectableCss;
  skipToContent?: SkipNavStyles;
  websiteName?: InjectableCss;
}
const navigationMenuItemTextColor= "#FFFFFF";
const navigationMenuItemTextColorUnderlineOnHover= "#FFFFFF";
const CategoryOrContentPageLinkTextColor = "#042359";
const CategoryOrContentPageLinkTextHoverColor = "#54A8CC";
const CategoryOrContentPageLinkTextHoverUnderlineColor = "#54A8CC";
const CategoryMenuArrowColor = "#54A8CC";

const secondaryCategoryTextColor= "#042359";
const secondaryCategoryTextHoverColor= "#54A8CC";
const verticalLineSeparator = "#C9E6EE";
const ExpandedMenuBlockOrTextBackground= "#C9E6EE";
const ExpandedMenuArrowColor= "#042359";
const QuickLinksTextColor ="#55A9CB";
const QuickLinksTextHoverColor ="#042359";
export const headerStyles: HeaderStyles = {
  page: {
    fullWidth: [true, true, false, false, false],
    css: css`
        a {
            background-color: transparent;
            color: #253746;
            transition: color 0.35s cubic-bezier(0.3, 0.86, 0.36, 0.95);
            -webkit-text-decoration: none;
            text-decoration: none;
          
            &:hover {
              -webkit-text-decoration: none;
              text-decoration: none;
              color: #c8102e;
            }
          }
          
          strong {
            font-weight: bolder;
          }
          
          img {
            border-style: none;
          }
          
          button {
            font-family: inherit;
            font-size: 100%;
            line-height: 1.15;
            margin: 0;
            overflow: visible;
            text-transform: none;
            -webkit-appearance: button;
          }
          
          input {
            font-family: inherit;
            font-size: 100%;
            line-height: 1.15;
            margin: 0;
            overflow: visible;
          }
          
          [type="submit"] {
            -webkit-appearance: button;
          }
          
          [type="search"] {
            -webkit-appearance: textfield;
            outline-offset: -2px;
          }
          
          * {
            box-sizing: inherit;
          }
          
          &:after {
            box-sizing: inherit;
          }
          
          &:before {
            box-sizing: inherit;
          }
          
          ul {
            margin: 0 0 22px;
          }
          
          input[type="search"] {
            -webkit-appearance: none;
            background-color: transparent;
            border: 1px solid;
            border-radius: 0;
            min-width: 0;
            padding: 1.2rem 2.4rem;
            transition: border-color 0.35s cubic-bezier(0.3, 0.86, 0.36, 0.95);
            width: 100%;
          
            &:focus {
              box-shadow: none;
              outline: none;
            }
          
            &:hover {
              box-shadow: none;
              outline: none;
            }
          }
          
          .as-header {
            position: relative;
            z-index: 101;
          
            .as-container {
              max-width: 1310px;
            }
          
            .as-user-control {
              margin: 0 0 0 30px;
            }
          }
          
          .as-header-area {
            align-items: center;
            display: flex;
            justify-content: flex-end;
          }
          
          .as-serach-form {
            display: none;
            margin: 0;
            position: relative;
          
            .as-header-form-group {
              border: 1px solid rgba(152, 164, 174, 0.2);
              border: 1px solid #54a8cc;
              display: flex;
              width: 277px;
              padding-left: 0px;
              border-radius: 35px;
            }
          
            .as-form-button {
              align-items: center;
              background: rgba(152, 164, 174, 0.2);
              background: #54a8cc;
              border: 0;
              cursor: pointer;
              display: flex;
              height: 32px;
              justify-content: center;
              padding: 0px;
              width: 40px;
              border-bottom-right-radius: 50%;
              border-top-right-radius: 50%;
              margin-right: -1px;
              svg {
                height: 17px;
                width: 17px;
              }
              path {
                transition: fill 0.3s ease;
              }
            }
          
            [type="search"] {
              border: 0;
              color: #253746;
              flex: 1 1 auto;
              font-family: "Inter Tight", Arial;
              font-size: 13px;
              font-weight: 400;
              height: 32px;
              outline: none;
              padding: 2px 12px;
              padding: 0px 15px;
              border-top-left-radius: 50px;
              border-bottom-left-radius: 50px;
              &::placeholder {
                color: #54a8cc;
                opacity: 0.5;
                transition: color 0.3s ease;
              }
          
              &:focus {
                &::placeholder {
                  color: rgba(37, 55, 70, 0.4);
                  color: #54a8cc;
                  opacity: 1;
                }
              }
            }
          }
          
          .as-topmenu {
            display: none;
            font-size: 16px;
            line-height: 1.2;
            margin: 0 38px;
            list-style: none;
            margin: 0;
            padding: 0;
          
            li {
              margin: 0 0 37px;
            }
          
            a {
              color: ${QuickLinksTextColor};
              transition: color 0.3s ease;
              &:hover {
                color: ${QuickLinksTextHoverColor};

              }
            }
          
            .as-account-block {
              li {
                margin: 0 0 7px;
              }
            }
          }
          
          .as-user-control {
            display: flex;
            position: absolute;
            right: 17;
            top: 50%;
            transform: translateY(-50%);
            z-index: 11;
            list-style: none;
            margin: 0;
            padding: 0;
          
            li {
              margin: 0 0 0 8px;
            }
          
            > li {
              > a {
                display: block;
                height: 22px;
                path {
                  fill: ${QuickLinksTextColor};
                }
                &:hover {
                  path {
                    fill: ${QuickLinksTextHoverColor};
                  }
                }
              }
              > div , > span {
                > a {
                display: block;
                height: 22px;
                fill: ${CategoryOrContentPageLinkTextColor};
                &:hover {
                  path {
                    fill: ${CategoryOrContentPageLinkTextHoverColor};
                  }
                }
              }
            }
            }
          
            svg {
              height: 100%;
              max-width: 100%;
              vertical-align: top;
            }
          
            path {
              fill: #fff;
              transition: fill 0.3s ease;
            }
          }
          
          .as-logo {
            position: relative;
            width: 182px;
          
            img {
              vertical-align: top;
              width: 100%;
            }
          }
          
          .as-account-block {
            position: relative;
          
            .as-user-list {
              background: #fff;
              border-bottom: 3px solid #F96523;
              box-shadow: 0 6px 6px rgba(0, 42, 83, 0.16);
              font-size: 12px;
              list-style: none;
              margin: 5px 0 0;
              padding: 20px 15px 15px;
              position: absolute;
              right: 0;
              top: 100%;
              width: 150px;
              z-index: 111;
              &:empty {
                display: none;
              }
              li {
                a {
                  span {
                    color: #042359 !important;
                  }
                  &.as-sign-out-link{
                    color: #042359 !important;
                    &:hover {
                      color: #042359 !important;
                    }
                  }
                }
              }
          }
            
          
            li {
              margin: 0 0 7px;
            }
          
            .as-user-name {
              color: #F96523;
              display: block;
              font-size: 12px;
              font-weight: 700;
              padding: 0;
            }
          
            a {
              strong {
                font-size: 12px;
                font-weight: 700;
              }
            }
          }
          
          .as-header-nav-wrap {
            display: flex;
            padding: 20px 48px 18px;
            position: relative;
            z-index: 1;
          
            &:before {
              background-color: #55A9CB;
              background-image: linear-gradient(to right,#C9E6EE 10%,#55A9CB 30%,#042359 70%);
              bottom: 0;
              content: "";
              left: -100vw;
              position: absolute;
              right: -100vw;
              top: 0;
              z-index: -1;
            }
          }
          
          .as-navigation {
            margin: 0 0 0 auto;
          }
          
          .as-nav {
            list-style: none;
            margin: 0;
            padding: 30px 38px 12px;
          
            > li {
              margin: 0 0 37px;
          
              > a {
                color: #042359;
                display: block;
                font-size: 25px;
                letter-spacing: 0.75px;
                padding-right: 25px;
                position: relative;
                text-transform: uppercase;
          
                &:hover {
                  &:after {
                    opacity: 1;
                  }
                }
          
                &:before {
                  border-color: #042359;
                  border-style: solid;
                  border-width: 0 2px 2px 0;
                  content: "";
                  height: 14px;
                  position: absolute;
                  right: 7px;
                  top: 9px;
                  transform: rotate(-45deg);
                  transition: border 0.3s ease;
                  width: 14px;
                }
          
                &:after {
                  background: ${navigationMenuItemTextColorUnderlineOnHover};
                  border-radius: 5px;
                  bottom: 0;
                  content: "";
                  display: none;
                  height: 3px;
                  left: 0;
                  opacity: 0;
                  position: absolute;
                  right: 0;
                }
              }
            }
          }
          
          .as-dropdown {
            background: #dce0e4;
            bottom: 0;
            left: 0;
            overflow-y: auto;
            padding: 12px 40px 20px;
            position: fixed;
            top: 86px;
            transform: translateX(100%);
            transition: visibility 0.3s ease, opacity 0.3s ease, transform 0.3s ease;
            width: 100vw;
            z-index: 11;
            &.extra{
              width: 100%;
              height: 100px;
              top: 60%!important;
              background: transparent;
            }
            .as-menu-title {
              color: #042359;
              display: block;
              font-size: 30px;
              letter-spacing: 0.9px;
              line-height: 1.2;
              margin: 0 0 28px;
            }
          
            .as-menu-sub-title {
              color: #042359;
              display: block;
              font-size: 25px;
              letter-spacing: 0.25px;
              line-height: 1.2;
              margin: 0 0 28px;
              padding: 3px 0 0;
            }
          
            .as-back-btn {
              color: #042359;
              display: block;
              font-size: 23px;
              font-weight: 700;
              line-height: 1.2;
              margin: 0 0 32px;
              padding: 0 0 0 19px;
              position: relative;
          
              &:hover {
                color: #253746;
              }
          
              &:before {
                border-color: #042359;
                border-style: solid;
                border-width: 0 2px 2px 0;
                content: "";
                height: 12px;
                left: 0;
                position: absolute;
                top: 7px;
                transform: rotate(135deg);
                transition: border 0.3s ease;
                width: 12px;
              }
          
              &:after {
                display: none;
              }
            }
          }
          
          .as-dropdown-wrap {
            > ul {
              list-style: none;
              margin: 0;
              padding: 0;
          
              > li {
                margin: 0 0 35px;
          
                &:hover {
                  > .as-sub-dropdown {
                    opacity: 1;
                    visibility: visible;
                  }
                }
              }
            }
          
            li {
              > a {
                color:  ${CategoryOrContentPageLinkTextColor};
                display: block;
                font-size: 25px;
                letter-spacing: 0.25px;
                line-height: 1.5;
                position: relative;
                transition: color 0.3s ease, border 0.3s ease;
          
                &:hover {
                  &:after {                    
                  }
                }
              }
            }
          
            .as-sub-opener {
              padding-right: 25px;
          
              &:after {
                border-color: #042359;
                border-style: solid;
                border-width: 0 2px 2px 0;
                content: "";
                height: 14px;
                position: absolute;
                right: 0;
                top: 12px;
                transform: rotate(-45deg);
                transition: border 0.3s ease;
                width: 14px;
              }
            }
          
            .as-sub-sub-opener {
              padding-right: 25px;
          
              &:after {
                border-color: #253746;
                border-style: solid;
                border-width: 0 2px 2px 0;
                content: "";
                height: 14px;
                position: absolute;
                right: 0;
                top: 12px;
                transform: rotate(-45deg);
                transition: border 0.3s ease;
                width: 14px;
              }
            }
          }
          
          .as-sub-dropdown {
            background: #dce0e4;
            bottom: 0;
            left: 0;
            padding: 12px 39px 20px;
            position: fixed;
            top: 86px;
            transform: translateX(100%);
            transition: visibility 0.3s ease, opacity 0.3s ease, transform 0.3s ease;
            width: 100vw;
            z-index: 11;
          
            .as-sub-sub-dropdown {
              border: 0;
            }
          
            > ul {
              list-style: none;
              margin: 0;
              padding: 0;
          
              > li {
                margin: 0 0 15px;
          
                &:hover {
                  > .as-sub-sub-dropdown {
                    opacity: 1;
                    visibility: visible;
                  }
                }
              }
            }
          }
          
          .as-sub-sub-dropdown {
            background: #dce0e4;
            bottom: 0;
            left: 0;
            padding: 12px 39px 20px;
            position: fixed;
            top: 86px;
            transform: translateX(100%);
            transition: visibility 0.3s ease, opacity 0.3s ease, transform 0.3s ease;
            width: 100vw;
            z-index: 11;
          
            > ul {
              list-style: none;
              margin: 0;
              padding: 0;
          
              > li {
                margin: 0 0 15px;
              }
            }
          }
          
          .as-call-out-box {
            background: ${ExpandedMenuBlockOrTextBackground};
            border-radius: 20px;
            color: #013d54;
            display: block;
            font-size: 20px;
            margin: 0 auto;
            padding: 25px 20px 12px;
            text-align: center;
            transition: box-shadow 0.3s ease;
            width: 307px;
          
            &:hover {
              box-shadow: 0 3px 3px rgba(0, 0, 0, 0.16);
              color: #013d54;
          
              .as-text {
                color: #013d54;
          
                span {
                  display: inline;
                }
          
                &:after {
                  border-color: #013d54;
                }
              }
            }
          
            .as-ttl {
              display: block;
              font-weight: 700;
              line-height: 1.25;
              margin: 0 0 9px;
            }
          
            .as-text {
              color: #c8102e;
              display: inline-block;
              font-size: 14px;
              font-weight: 700;
              line-height: 1.2;
              padding: 0 13px 0 1px;
              position: relative;
              vertical-align: top;
          
              span {
                display: inline;
              }
          
              &:after {
                border-color: ${ExpandedMenuArrowColor};
                border-style: solid;
                border-width: 0 2px 2px 0;
                content: "";
                height: 7px;
                position: absolute;
                right: 0;
                top: 11px;
                transform: rotate(-45deg);
                transition: border 0.3s ease;
                width: 7px;
              }
            }
          }
          
          .as-nav-opener {
            display: block;
            height: 19px;
            left: 3px;
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            width: 32px;
          
            span {
              background: #fff;
              border-radius: 3px;
              display: block;
              height: 1px;
              left: 0;
              position: absolute;
              right: 0;
              transition: opacity 0.3s ease, transform 0.3s ease, top 0.3s ease;
              top: 9px;
            }
          
            &:after {
              background: #fff;
              border-radius: 3px;
              display: block;
              height: 1px;
              left: 0;
              position: absolute;
              right: 0;
              transition: opacity 0.3s ease, transform 0.3s ease, top 0.3s ease;
              content: "";
              top: 19px;
            }
          
            &:before {
              background: #fff;
              border-radius: 3px;
              display: block;
              height: 1px;
              left: 0;
              position: absolute;
              right: 0;
              transition: opacity 0.3s ease, transform 0.3s ease, top 0.3s ease;
              content: "";
              top: 0;
            }
          }
          
          
          
          
          .as-nav-holder {
            flex: 1;
            padding: 5px 0;
          }
          
          .as-details {
            background: #042359;
            color: #fff;
            margin-top: auto;
            padding: 51px 22px 25px;
            a{
              color: #fff;
              span{
                color: #fff;
              }
            }
            .as-btn {
              display: block;
              margin: 0 auto;
              max-width: 370px;
              text-align: center;
              width: 100%;
          
              &:hover {
                background: #9adbe8;
                color: #253746;
              }
            }
          
            .as-details-list {
              font-family: "Inter Tight", Arial;
              font-size: 16px;
              font-weight: 400;
              list-style: none;
              margin: 0;
              padding: 0 18px 27px;
              &.hide-border hr{
                display:none;
              }
              li {
                margin-bottom: 8px;
                a,button{
                  color: #fff;
                }

              }
            }
          
            .as-details-title {
              display: block;
              font-size: 23px;
              font-weight: 700;
              line-height: 1.2;
              padding: 0 18px 16px;
              a {
                color: #fff;
                display: block;
                position: relative;
                transition: color 0.3s ease;
          
                &:after {
                  border-color: #fff;
                  border-style: solid;
                  border-width: 0 2px 2px 0;
                  content: "";
                  height: 14px;
                  position: absolute;
                  right: 7px;
                  top: 7px;
                  transform: rotate(-45deg);
                  transition: border 0.3s ease;
                  width: 14px;
                }
          
                &:hover {
                  color: #55A9CB;
          
                  &:after {
                    border-color: #55A9CB;
                  }
                }
              }
            }
          }
          
          .as-nav-form {
            padding: 34px 37px 15px;
          
            .as-nav-form-wrap {
              border-bottom: 2px solid #042359;
              display: flex;
            }
          
            button {
              align-items: center;
              background: transparent;
              border: 0;
              cursor: pointer;
              display: flex;
              height: 32px;
              justify-content: center;
              padding: 5px;
              width: 38px;
          
              svg {
                height: 22px;
                width: 22px;
              }
          
              path {
                fill: #253746;
                transition: fill 0.3s ease;
              }
          
              &:hover {
                path {
                  fill: #c8102e;
                }
              }
            }
          
            [type="search"] {
              border: 0;
              color: #253746;
              flex: 1 1 auto;
              font-family: "Inter Tight", Arial;
              font-size: 18px;
              font-weight: 400;
              height: 36px;
              letter-spacing: 0.18px;
              line-height: 1.2;
              outline: none;
              padding: 5px 0;
          
              &::placeholder {
                color: #253746;
                opacity: 1;
                transition: color 0.3s ease;
              }
          
              &:focus {
                &::placeholder {
                  color: rgba(37, 55, 70, 0.4);
                  opacity: 1;
                }
              }
            }
          }
          
          .as-add-menu {
            border-top: 2px solid #9adbe8;
            list-style: none;
            margin: 0 38px;
            padding: 46px 0 48px;
          
            li {
              margin: 0 0 37px;
          
              &:last-child {
                margin-bottom: 0;
              }
            }
          
            a {
              color: #042359;
              display: block;
              font-size: 25px;
              letter-spacing: 0.75px;
              position: relative;
              text-transform: uppercase;
          
              &:before {
                border-color: #042359;
                border-style: solid;
                border-width: 0 2px 2px 0;
                content: "";
                height: 14px;
                position: absolute;
                right: 7px;
                top: 9px;
                transform: rotate(-45deg);
                transition: border 0.3s ease;
                width: 14px;
              }
            }
          }
          
          .as-wrapper {
            overflow: hidden;
            position: relative;
            width: 100%;
          }
          
          .as-container {
            &:after {
              clear: both;
              content: "";
              display: block;
            }
          
            margin: 0 auto;
            max-width: 1180px;
            padding-left: 20px;
            padding-right: 20px;
            width: 100%;
          }
          
          .as-hidden {
            height: 1px;
            left: -9999px;
            overflow: hidden;
            position: absolute;
            top: auto;
            width: 1px;
          }
          
          .as-btn {
            color: #fff;
            display: inline-block;
            font-size: 16px;
            letter-spacing: 0.48px;
            line-height: 1.2;
            transition: background 0.3s ease, color 0.3s ease;
            vertical-align: top;
          }
          
          .as-btn-primary {
            background: #c8102e;
            border-radius: 10px;
            color: #fff;
            font-weight: 700;
          
            &:hover {
              background: #253746;
              color: #fff;
            }
          }
          
          .as-btn-lg {
            border-radius: 20px;
            font-size: 22px;
            padding: 22px 10px 20px;
          }
          
          .js-slide-hidden {
            position: absolute !important;
            left: -9999px !important;
            top: -9999px !important;
            display: block !important;
          }
          .as-visible-lg {
            display: none;
          }
          @media (min-width: 1024px) {
            
            .as-header-area {
              padding: 12px 6px;
              padding-left: 0px;
            }
          
            .as-serach-form {
              display: block;
              width: 100%;
            }
          
            .as-topmenu {
              display: flex;
              margin: 0;
          
              li {
                margin: 0 0 0 28px;
                width: max-content;
              }
            }
          
            .as-user-control {
              position: static;
              transform: none;
          
              li {
                margin: 0;
              }
          
              > li {
                > a, > span {
                  height: 18px;
                  width: 21px;
                }
              }
          
              path {
                fill: #253746;
              }
            }
          
            .as-logo {
              width: 333px;
            }
          
            .as-account-block {
              .as-user-list {
                left: 50%;
                right: auto;
                transform: translateX(-50%);
              }
            }
          
            .as-header-nav-wrap {
              padding: 36px 0 35px;
            }
          
            .as-nav {
              display: flex;
              margin: 0 -11px 0 0;
              padding: 0;
          
              > li {
                margin: 0 0 0 15px;
          
                > a {
                  color: ${navigationMenuItemTextColor};
                  font-size: 16px;
                  letter-spacing: 0.36px;
                  padding: 8px 10px;
          
                  &:before {
                    display: none;
                  }
          
                  &:after {
                    display: block;
                  }
                }
              }
          
              > li.as-hover {
                > a {
                  &:after {
                    opacity: 1;
                  }
                }
              }
          
              .as-hover {
                > .as-dropdown {
                  &.extra{
                    top:60%!important;
                  }
                  left: 50% !important;
                  opacity: 1;
                  top: 100% !important;
                  visibility: visible;
                }
              }
            }
          
            .as-dropdown {
              background: #fff;
              bottom: auto;
              box-shadow: 0 6px 6px rgba(0, 42, 83, 0.16);
              left: 50%;
              opacity: 0;
              overflow: visible;
              padding: 0;
              position: absolute;
              top: 100%;
              transform: translateX(-50%);
              visibility: hidden;
          
              .as-back-btn {
                display: none;
              }
          
              .as-menu-sub-title {
                display: none;
              }
          
              .as-menu-title {
                display: none;
              }
            }
          
            .as-dropdown-wrap {
              margin: 0 auto;
              max-width: 1014px;
              overflow: hidden;
              padding: 25px 33px 30px;
          
              > ul {
                border-right: 1px solid ${verticalLineSeparator};
                padding: 0 30px 0 0;
                position: relative;
                width: 307px;
          
                > li {
                  margin: 0 0 7px;
          
                  &:hover {
                    > a {
                                
                      &:after {                        
                      }
                    }
                  }
          
                  > a {
                    border-bottom: 2px solid transparent;
                    font-weight: 700;
                  }
                }
              }
          
              li {
                > a {
                  font-size: 16px;
                  letter-spacing: 0.16px;
                  line-height: 1.875;
                }
              }
          
              .as-sub-opener {
                &:after {
                  height: 7px;
                  right: 9px;
                  width: 7px;
                }
              }
          
              .as-sub-sub-opener {
                &:after {
                  height: 7px;
                  right: 9px;
                  width: 7px;
                }
              }
            }
          
            .as-sub-dropdown {
              background: none;
              border-right: 1px solid ${verticalLineSeparator};
              left: 100%;
              opacity: 0;
              padding: 0 29px 0 32px;
              position: absolute;
              top: 0;
              transform: translateX(0);
              visibility: hidden;
              width: 338px;
          
              &:before {
                bottom: 0;
                content: "";
                position: absolute;
                right: 100%;
                top: 0;
                width: 30px;
              }
          
              > ul {
                > li {
                  margin: 0 0 9px;
          
                  &:hover {
                    > a {
                      border-color: ${secondaryCategoryTextHoverColor};
                      color: ${secondaryCategoryTextHoverColor};
          
                      &:after {
                        border-color: ${secondaryCategoryTextHoverColor};
                      }
                    }
                  }
                }
              }
            }
          
            .as-sub-sub-dropdown {
              background: none;
              border-right: 1px solid ${verticalLineSeparator};
              left: 100%;
              opacity: 0;
              padding: 0 29px 0 32px;
              position: absolute;
              top: 0;
              transform: translateX(0);
              visibility: hidden;
              width: 338px;
          
              &:before {
                bottom: 0;
                content: "";
                position: absolute;
                right: 100%;
                top: 0;
                width: 30px;
              }
          
              > ul {
                > li {
                  margin: 0 0 9px;
          
                  &:hover {
                    > a {
                      border-color: #c8102e;
                      color: #c8102e;
          
                      &:after {
                        border-color: #c8102e;
                      }
                    }
                  }
                }
              }
            }
          
            .as-nav-item {
              .as-dropdown-wrap {                          
                > ul {                            
                  > li {
                    &:hover {
                      > a {
                        border-color: transparent;
                        font-size: 3k;
                        &:after {
                          
                          font-size: 2k;
                        }
                      }
                    }
          
                    > a {
                      &:hover {
                        border-color: ${CategoryOrContentPageLinkTextHoverColor};
                        color: ${CategoryOrContentPageLinkTextHoverColor};
                        font-size: 1k;
          
                        &:after {
                          border-color: ${CategoryOrContentPageLinkTextHoverColor};
                          font-size: 4k;
                        }
                      }
                    }
                  }
                }
              }
            }
            .as-dropdown-wrap-alt {
              .as-dropdown-wrap {
                align-items: flex-start;
                display: flex;
                padding: 25px 33px 14px;
          
                > ul {
                  border: 0;
                  padding: 0 22px 0 0;
                  width: 67.7%;
          
                  > li {
                    &:hover {
                      > a {
                        border-color: transparent;
                        font-size: 3k;
                        &:after {                          
                          font-size: 2k;
                        }
                      }
          
                      .as-sub-dropdown {
                        display: block !important;
                        opacity: 1;
                        visibility: visible;
                      }
                    }
          
                    > a {
                      &:hover {
                        border-color: ${CategoryOrContentPageLinkTextHoverColor};
                        color: ${CategoryOrContentPageLinkTextHoverColor};
                        font-size: 1k;
          
                        &:after {
                          border-color: ${CategoryOrContentPageLinkTextHoverColor};
                          font-size: 4k;
                        }
                      }
                    }
                  }
                }
          
                .as-sub-dropdown {
                  border: 0;
                  display: block !important;
                  margin: 0 -34px 0 0;
                  opacity: 1;
                  padding: 5px 0 0;
                  position: static !important;
                  visibility: visible;
                  width: auto;
          
                  ul {
                    display: flex;
                    flex-wrap: wrap;
                    margin: 0 -10px;
          
                    li {
                      padding: 0 35px 0 10px;
                      width: 50%;
                    }
                  }
                }
              }
            }
          
            .as-call-out-box {
              margin: 12px 0 0;
            }
          
            .as-nav-opener {
              display: none;
            }
          
            .as-topbar-active {
              .as-nav-drop {
                height: auto;
              }
            }
          
            .as-nav-holder {
              padding: 0;
              position: static;
            }
          
            .as-add-menu {
              display: none;
            }
          
            .as-details {
              display: none;
            }
          
            .as-hidden-lg {
              display: none;
            }
            .as-visible-lg {
              display: list-item;
            }
          
            .as-nav-form {
              display: none;
            }
          }
          
          @media (min-width: 1140px) {
            .as-nav {
              > li {
                margin: 0 0 0 23px;
          
                > a {
                  font-size: 18px;
                  padding: 8px 16px;
                }
              }
            }
          }
          
          @media (max-width: 1023px) {
            .as-nav {
              .as-selected {
                > .as-dropdown {
                  transform: none;
                }
              }
            }
          
            .as-dropdown {
              display: block !important;
              overflow: hidden;
              overflow-y: auto;
          
              .js-slide-hidden {
                left: 0 !important;
                position: fixed !important;
                top: 86px !important;
              }
            }
            .as-dropdown.js-slide-hidden {
              left: 0 !important;
              position: fixed !important;
              top: 86px !important;
            }
            .as-sub-dropdown {
              display: block !important;
              overflow: hidden;
              overflow-y: auto;
            }
          
            .as-sub-sub-dropdown {
              display: block !important;
              overflow: hidden;
              overflow-y: auto;
            }
            .as-nav-active {
              overflow: hidden;
          
              .as-nav-drop {
                transform: translateX(0);
              }
            }
          
            .as-nav-drop {
              overflow: hidden;
              background: #dce0e4;
              bottom: 0;
              height: calc(var(--full-viewport) - 63px);
              left: 0;
              position: fixed;
              top: 63px;
              transform: translateX(100%);
              transition: transform 0.35s cubic-bezier(0.3, 0.86, 0.36, 0.95);
              width: 100%;
          
              &:before {
                background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='450.873' height='542.785'%3E%3Cpath fill='%23fff' d='M384.918 157.913c87.941 88.068 87.941 230.816 0 318.866-88.087 88.009-230.836 88.009-318.934 0-87.979-88.049-87.979-230.8 0-318.866L222.822 1.195c2.639-2.688 5.24 0 5.24 0l95.246 95.107a3.774 3.774 0 0 1 0 5.376l-156.77 156.774a83.336 83.336 0 1 0 117.865 0l-34.039-34.118c-2.767-2.688 0-5.387 0-5.387l95.067-95.152a3.758 3.758 0 0 1 5.368 0Z' data-name='%D0%9A%D0%BE%D0%BD%D1%82%D1%83%D1%80 230' opacity='.231'/%3E%3C/svg%3E");
                background-size: 100% 100%;
                bottom: -16px;
                content: "";
                height: 542px;
                opacity: 0.4;
                position: absolute;
                right: -81px;
                width: 450px;
                z-index: -1;
              }
            }
          
            .as-nav-wrap {
              display: flex;
              flex-direction: column;
              height: 100%;
            }
          
            .as-nav-holder {
              overflow: hidden;
              overflow-y: auto;
            }
            .as-dropdown-wrap {
              >ul {
                .as-selected {
                  >.as-sub-dropdown {
                    transform: none;
                  }
                }
              }
            }
          }
          
          @media (max-width: 767px) {
            .as-sub-dropdown {
              > ul {
                a {
                  font-size: 20px;
                }
              }
            }
          
            .as-sub-sub-dropdown {
              > ul {
                a {
                  font-size: 20px;
                }
              }
            }
          }
          .as-card-popup{
            position:relative;
          }      
        
        `
  }
};

const styles = headerStyles;

const Header = ({ id, siteName, session, toaster, history, myAccountPageUrl, signInUrl, userName,firstName, dismissRfqUpdates, shellContext }: Props) => {
  const { isCurrentPage, isEditing, isInShell } = shellContext;
  const isShell = isCurrentPage && isInShell;
  const isEdit = isCurrentPage && isEditing && isInShell;
  const viewMyDashboardClickHandler = () => {
    if (myAccountPageUrl) {
      history.push(myAccountPageUrl);
    }
  };

  useEffect(() => {
    if (session.hasRfqUpdates && myAccountPageUrl) {
      toaster.addToast({
        body: (
          <>
            <Typography>{translate("You have new quote information.")}</Typography>
            <Link onClick={viewMyDashboardClickHandler}>{translate("View My Dashboard")}</Link>
          </>
        ),
        messageType: "info",
        timeoutLength: 1000 * 60 * 60 * 24 * 365,
        onClose: () => {
          dismissRfqUpdates();
        },
      });
    }
  }, [myAccountPageUrl]);
  useEffect(() => {
    let isOpenCloseInitiated = false;
    const interval = setInterval(() => {
      if (typeof window === 'object' && typeof document === 'object' && !isOpenCloseInitiated) {
        InitOpenClose();
        InitMobileNav();
        initMobileHeaderNavOpenClose();
        isOpenCloseInitiated = true;
        clearInterval(interval);
      }
    }, 300);
  }, []);

  const afterHeader = React.createRef<HTMLSpanElement>();
  return (
    <>
      <Page as="div" isHeader={true} {...styles.page}>
        <AspenZone contentId={id} zoneName="TopBar" hideWrapper={true} />
        <Typography as="header" className="as-header">
          <div className="as-container">
            <div className="as-header-area">
              <AspenZone contentId={id} zoneName="Search" hideWrapper={true} />
              <AspenZone contentId={id} zoneName="QuickLinks" hideWrapper={true} />
              {!session.isAuthenticated && <ul className="as-visible-lg as-topmenu">
                <li className="as-account-block">
                {!session.isAuthenticated && <a href={signInUrl}>{translate("Login")}</a>}
                </li>
              </ul> }
              {isEdit && <AspenZone contentId={id} zoneName="MyAccountLinks" hideWrapper={true} />}
              {session.isAuthenticated && <ul className="as-visible-lg as-user-control">
                <li className="as-account-block">
                  <a href="#" className="as-opener">
                    <Person />
                  </a>
                  <ul className="as-user-list  js-slide-hidden">
                  {!isEdit && <AspenZone contentId={id} zoneName="MyAccountLinks" hideWrapper={true} />}
                  </ul>
                </li>
              </ul>}
              <ul className="as-user-control">
                <li className="as-hidden-lg as-account-block">
                  {session.isAuthenticated && <a href={myAccountPageUrl}>
                    <Person />
                  </a>}
                  {!session.isAuthenticated && <a href={signInUrl}>
                    <Person />
                  </a>}
                </li>
                <AspenZone contentId={id} zoneName="Cart" tagNameAs="li" className="as-card-popup"/>
              </ul>
            </div>
           
            <div className="as-header-nav-wrap">
              <AspenZone contentId={id} className="as-logo" tagNameAs="div" zoneName="Header Logo"></AspenZone>
              <nav className="as-navigation">
                <a className="as-nav-opener" aria-expanded="false" aria-haspopup="true"><span></span></a>
                <div className="as-nav-drop">
                  <div className="as-nav-wrap">
                  {!isEdit && <AspenZone contentId={id} zoneName="MobileSearch" hideWrapper={true} />}
                    <div className="as-nav-holder">
                      <AspenZone contentId={id} zoneName="MainNavigation" hideWrapper={true} />
                      <AspenZone zoneName="AdditionalMenu" contentId={id} hideWrapper={true}></AspenZone>
                      <div className="as-details">
                        {session.isAuthenticated && <span className="as-details-title"><a href="#">{translate("Account Details")}</a></span>}
                        <ul className={`as-details-list ${!session.isAuthenticated?"hide-border":""}`}>
                          {!isEdit && <AspenZone contentId={id} zoneName="MobileMyAccountLinks" hideWrapper={true} />}
                        </ul>
                        {!isEdit && <AspenZone zoneName="MobileHeaderRequestProductSamples" contentId={id} hideWrapper={true}></AspenZone>}
                      </div>
                    </div>
                  </div>
                </div>
              </nav>
              
            </div>
            {isEdit && <AspenZone contentId={id} zoneName="MobileSearch" hideWrapper={true} />}
            {isEdit && <AspenZone zoneName="MobileHeaderRequestProductSamples" contentId={id} hideWrapper={true}></AspenZone>}
              {isEdit && <AspenZone zoneName="MobileMyAccountLinks" contentId={id} hideWrapper={true} />}
          </div>
        </Typography>
      </Page>
    </>
  );
};

const pageModule: PageModule = {
  component: connect(mapStateToProps, mapDispatchToProps)(withToaster(withHistory(withIsInShell(Header)))),
  definition: {
    hasEditableTitle: false,
    hasEditableUrlSegment: false,
    pageType: "System",
  },
};

export const HeaderContext = "HeaderContext";

export default pageModule;
